
















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class EmptyPlanAction extends Vue {
  @Prop() empty;

  handleCreate() {
    this.$helper.toFusionPath(this, "hfox", { name: "plan-create" });
  }
}
export default EmptyPlanAction;
